<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    resource="billing_skus" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SKUSubcategoryDetail',
  mixins: [WindowsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [],
    }
  },
}
</script>
